<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-10">
      <legend class="usa-legend usa-legend--large">Customer (Agency) Approval</legend>
    </div>
  </div>
  <form [formGroup]="customerApprovalForm">
    <!-- <fieldset class="usa-fieldset"> -->
    @if (customerApprovalForm.get('status').invalid) {
      <div class="grid-row">
        <div class="usa-alert usa-alert--warning usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              Please Select a Status to See Results
            </p>
          </div>
        </div>
      </div>
    }
    <div class="grid-row grid-gap-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" aria-label="Registration Type" for="customer-approval-type">Registration Type</label>
        <select aria-label="Registration Type Dropdown" title="Registration Type Dropdown" id="customer-approval-type" class="usa-select width-full" formControlName="registrationType">
          <option [ngValue]="null" selected disabled>Choose...</option>
          @for (registrationType of registrationTypes; track registrationType) {
            <option [ngValue]="registrationType">{{registrationType}}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" aria-label="Registration Status" for="customer-approval-status">Status</label>
        <select aria-label="Registration Status" (change)="onSelectedStatus()" title="Registration Status Dropdown" id="customer-approval-status" class="usa-select width-full" formControlName="status">
          <option [ngValue]="null" selected disabled>Choose...</option>
          @for (status of statusList; track status) {
            <option [ngValue]="status.id">{{status.value}}</option>
          }
        </select>
      </div>
    </div>
  <!-- </fieldset> -->
</form>
@if (customers && customers.length>0) {
  <div class="padding-top-4">
    <span>
      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
        <use xlink:href="/assets/uswds/img/sprite.svg#file_download"></use>
      </svg>
      Right click on the report and select the appropriate options to export.
    </span>
  </div>
}
@if (this.customers?.length > 0) {
  <div class="grid-row margin-y-4">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ag-grid-angular
        class="ag-theme-alpine"
        [rowData]="customers"
        [domLayout]="domLayout"
        [pagination]="true"
        [paginationPageSize]="itemsPerPage"
        [columnDefs]="custApprColumnDefs"
        [rowHeight]="rowHeight"
        (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
}
</div>
